import { useIsScribeEnableRtlEnabled } from '@/features/flags';
import type { LanguageCode } from '@heidi/schema/ml-scribe';
import { buildSelectableDisplayLanguageCodes } from '@heidi/utils/i18n';
import { useMemo } from 'react';

/**
 * Display languages for account/settings pickers.
 * Excludes Arabic until Flagsmith `release-scribe-enable-rtl` is enabled.
 */
export const useSelectableDisplayLanguageCodes = (): LanguageCode[] => {
  const rtlEnabled = useIsScribeEnableRtlEnabled();
  return useMemo(() => buildSelectableDisplayLanguageCodes(rtlEnabled), [rtlEnabled]);
};
